import React, { Fragment, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';

const CONTENT = {
  en: {
    welcome: 'Welcome to WholesaleDai',
    subtitle: 'Your B2B E‑commerce Partner',
    body: 'WholesaleDai is a private B2B marketplace connecting verified Nepali businesses. Register your business, get verified, and source stock directly from wholesale sellers — with transparent pricing, clear minimum order quantities, and delivery across Nepal. Verification is typically completed within 24–48 hours of submitting your documents.',
  },
  ne: {
    welcome: 'व्होलसेलदाइमा स्वागत छ',
    subtitle: 'तपाईंको B2B इ-कमर्स साझेदार',
    body: 'व्होलसेलदाइ प्रमाणित नेपाली व्यवसायहरूलाई जोड्ने निजी B2B बजार हो। आफ्नो व्यवसाय दर्ता गर्नुहोस्, प्रमाणीकरण गराउनुहोस्, र थोक बिक्रेताहरूबाट सीधै सामान किन्नुहोस् — पारदर्शी मूल्य, स्पष्ट न्यूनतम अर्डर परिमाण, र नेपालभर डेलिभरीसहित। कागजात पेश गरेपछि प्रमाणीकरण सामान्यतया २४–४८ घण्टाभित्र पूरा हुन्छ।',
  },
};

export default function WelcomeInfoModal({ isOpen, onClose }) {
  const [lang, setLang] = useState('en');
  const content = CONTENT[lang];

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-30" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/60" aria-hidden="true" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="relative w-full max-w-2xl transform overflow-hidden rounded-2xl bg-white shadow-xl transition-all text-left">
                {/* Header with gradient and close */}
                <div className="bg-gradient-to-r from-brand-600 to-brand-700 px-4 py-5 sm:px-6 sm:py-6">
                  <button
                    type="button"
                    onClick={onClose}
                    className="absolute right-3 top-3 rounded-full p-1.5 text-white/90 hover:bg-white/20 hover:text-white focus:outline-none focus:ring-2 focus:ring-white/50 sm:right-4 sm:top-4"
                    aria-label="Close"
                  >
                    <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </button>
                  <Dialog.Title as="h2" className="text-xl font-bold text-white sm:text-2xl pr-10">
                    {content.welcome}
                  </Dialog.Title>
                  <p className="mt-1 text-brand-100 text-sm sm:text-base">
                    {content.subtitle}
                  </p>
                  {/* Language toggle */}
                  <div className="mt-4 flex gap-2">
                    <button
                      type="button"
                      onClick={() => setLang('en')}
                      className={`rounded-lg px-4 py-2 text-sm font-medium transition-colors ${
                        lang === 'en'
                          ? 'bg-white text-brand-700'
                          : 'bg-white/20 text-white hover:bg-white/30'
                      }`}
                    >
                      English
                    </button>
                    <button
                      type="button"
                      onClick={() => setLang('ne')}
                      className={`rounded-lg px-4 py-2 text-sm font-medium transition-colors ${
                        lang === 'ne'
                          ? 'bg-white text-brand-700'
                          : 'bg-white/20 text-white hover:bg-white/30'
                      }`}
                    >
                      नेपाली
                    </button>
                  </div>
                </div>

                {/* Body */}
                <div className="px-4 py-5 sm:px-6 sm:py-6">
                  <p className="text-gray-700 text-sm leading-relaxed sm:text-base sm:leading-relaxed">
                    {content.body}
                  </p>
                  <div className="mt-6 flex justify-end">
                    <button
                      type="button"
                      onClick={onClose}
                      className="inline-flex justify-center rounded-lg bg-brand-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2"
                    >
                      {lang === 'en' ? 'Got it' : 'ठीक छ'}
                    </button>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
